import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class Grids extends PureComponent {
  render() {
    const { className, children } = this.props;
    const cls = classNames({
      "weui-grids": true,
      [className]: className
    });
    return (
      <div className={ cls }>
        { children }
      </div>
    );
  }
}
